<template>
  <div class="absolute top-0 bottom-0 right-0">
    <div class="h-full flex items-end">
      <div
        @click="$router.push({...this.$route, query: {...this.$route.query, 'show-help': null}})"
        class="mx-4 my-4 bg-primary text-white rounded-full p-3 shadow-lg cursor-pointer hover:bg-primary-dark transition-all flex items-center"
      >
        <zeit-icon name="BookOpen" class="w-6 h-6" />
        <div class="px-3 font-medium ">Anleitung</div>
      </div>
    </div>

    <ZeitSidebar
      title="Anleitung"
      :open="$route.query['show-help'] !== undefined"
      @close="$router.push({...$route, query: {...$route.query, 'show-help': undefined}})">
        Foobar
      </ZeitSidebar>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  import ZeitIcon from '@/components/ui/ZeitIcon.vue';
  import ZeitSidebar from '@/components/ui/ZeitSidebar.vue';

  export default defineComponent({
    components: {
      ZeitIcon,
      ZeitSidebar,
    }
  })
</script>